import { render, staticRenderFns } from "./jumbotron.vue?vue&type=template&id=b636fc86&scoped=true"
import script from "./jumbotron.vue?vue&type=script&lang=js"
export * from "./jumbotron.vue?vue&type=script&lang=js"
import style0 from "./jumbotron.vue?vue&type=style&index=0&id=b636fc86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b636fc86",
  null
  
)

export default component.exports